<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
::-webkit-scrollbar {
  width: 0; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
::selection {
  background: #d3cea0;
}
html {
  overflow: scroll;
}
</style>
